import * as yup from "yup";

import { Shape } from "@/core/yup";

import { ChatInputFormType } from "./ConversationChatInput";

export const formSchemaMessage = yup.object<{}, Shape<ChatInputFormType>>({
    content: yup.string().required(),
});

export const formSchemaConversation = yup
    .object<{}, Shape<ChatInputFormType>>({
        title: yup.string().required(),
    })
    .concat(formSchemaMessage);
